module.exports = __webpack_public_path__ + "img/bgr-cardboard-boxes@1x.d189e408.png";